import { Box } from '@mui/material';
import { ProductTypeEnum } from '@utils/constants';

export function LatestProductStart({ productInfo }: any) {
  return (
    <>
      {productInfo?.latestProduct && (
        <Box display="flex" flexDirection="column">
          <Box
            display="flex"
            style={{
              fontWeight: 400,
              fontSize: '12px',
            }}
          >
            Start of application (
            {ProductTypeEnum[productInfo?.latestProduct?.type]})
          </Box>
          <Box
            display="flex"
            mt={0.5}
            style={{
              fontWeight: 500,
              fontSize: '12px',
            }}
          >
            {productInfo?.startDate}
          </Box>
        </Box>
      )}
    </>
  );
}
